import Base64Image from 'component/Base64Image'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  padding: 0.7rem 0;
  color: white;
  position: relative;
  background: var(--component-area-swiper--background);
`

export const StyledBase64Image = styled(Base64Image).attrs({ aspectRatio: null })`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`
